import React from 'react';

const EstimatePrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        //width: '90%', // Change the width as needed
        width: '270px',
        marginTop: '5px', // Adjust the top margin as needed
        marginLeft:'5px'
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const printStyles = `
        @media print {
            body {
                margin: 10px;
            }
        }
    `;

    return (
        <div style={containerStyle}>
            {/* Add print styles */}
            <style>{printStyles}</style>

            {/* Render your label content using the fetched data */}
            {labelData && (
                <div>
                    <h3 style={{ textAlign: 'center', marginTop: '0', marginBottom: '10px', color: 'blue', fontStyle: 'italic', fontFamily: 'Newtown, sans-serif' }}>
                        {labelData.KOTPrint.CompanyName}
                    </h3>

                    <h4 style={{ textAlign: 'center', marginTop: '0', marginBottom: '10px' }}>
                        {labelData.KOTPrint.IsReprint ? 'KOT BILL (Reprinted)' : 'KOT BILL'}
                    </h4>
                </div>
            )}

            {labelData && (
                <div>
                    <h4 style={{ marginTop: '0', marginBottom: '5px' }}>
                       
                        {new Date(labelData.KOTPrint.KOTDate).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        })}
                        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {new Date(`2000-01-01T${labelData.KOTPrint.KOTTime}`).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true,
                        })}
                    </h4>
                </div>
            )}

            {labelData && (
                <div>
                    <h4 style={{ marginTop: '0', marginBottom: '2px' }}>&nbsp;KOT No: {labelData.KOTPrint.KOTNumber}</h4>
                    <h4 style={{ marginTop: '0', marginBottom: '2px' }}>&nbsp;Table : {labelData.KOTPrint.TableName}</h4>
                </div>
            )}

            {labelData && (
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <td style={{ ...cellStyle, width: '50px' }}>
                                <h4 style={{ marginTop: '0px', marginBottom: '2px' }}>No</h4>
                            </td>

                            <td style={{ ...cellStyle, width: '300px' }}>
                                <h4 style={{ marginTop: '0', marginBottom: '2px' }}>Particular</h4>
                            </td>

                            <td style={{ ...cellStyle, width: '100px' }}>
                                <h4 style={{ marginTop: '0', marginBottom: '2px' }}>Qty</h4>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {labelData &&
                            labelData.KOTPrintItems.map((record, index) => (
                                <tr key={index} style={{ height: '45px' }}>
                                    <td style={{ ...cellStyle, width: '50px' }}>
                                        <label style={{ marginTop: '0px', marginBottom: '0px', fontFamily: 'Arial', fontSize: '14px' }}>
                                            {record.SerialNo}
                                        </label>
                                    </td>
                                    <td style={{ ...cellStyle, width: '300px', textAlign: 'left' }}>
                                        <label style={{ marginTop: '0px', marginBottom: '0px', fontFamily: 'Arial', fontSize: '14px', textAlign: 'left' }}>
                                           {record.ItemName}
                                        </label>
                                    </td>
                                    <td style={{ ...cellStyle, width: '100px' }}>
                                        <label style={{ marginTop: '0px', marginBottom: '0px', fontFamily: 'Arial', fontSize: '14px' }}>
                                            {record.Quantity}
                                        </label>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            )}

            {labelData && (
                <table style={tableStyle}>
                    <tr>
                        <td style={{ ...cellStyle, width: '500px', textAlign: 'right' }}>
                            <h3 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0px', marginBottom: '2px' }}>Total Qty</h3>
                        </td>
                        <td style={{ ...cellStyle, width: '80px', textAlign: 'right' }}>
                            <h3 style={{ marginRight: '10px', fontFamily: 'Arial', fontSize: '15px', marginTop: '0px', marginBottom: '2px' }}>{parseFloat(labelData.KOTPrint.TotalQty).toFixed(2)}</h3>
                        </td>
                    </tr>
                </table>
            )}

            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 1px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default EstimatePrint;

